// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"422e40f2","289":"025f79da"}[chunkId] + ".chunk.js";
};